import { Component } from '@angular/core';

@Component({
  selector: 'app-minute-warranties',
  templateUrl: './minute-warranties.component.html',
  styleUrls: ['./minute-warranties.component.scss']
})
export class MinuteWarrantiesComponent {

}
